import { z } from 'zod';

import { ApiDimensionTypes, DataExportDimensionIdSchema } from '../..';

const ApiCreateDimensionPropertyPathSchema = z.enum(['dimensions', 'tags.variableConfigs', 'tags.bestPracticeConfigs']);

const ApiDimensionTypesSchema = ApiCreateDimensionPropertyPathSchema.extract(['dimensions', 'tags.variableConfigs']);

export const ApiDimensionSchema = z.object({
  id: DataExportDimensionIdSchema,
  friendlyName: z.string(),
  type: z.string().optional(),
  column: z.string().optional(),
  eventType: z.string().optional(),
  uiGrouping: z.string().optional(),
  propertySourceCategory: z.string().optional(),
  variableName: z.string().optional(),
  uiFlags: z
    .object({
      showInConsentCategory: z.boolean().optional(),
      showInConsentTagMapping: z.boolean().optional(),
      showInSegments: z.boolean().optional(),
      showInDimensions: z.boolean().optional(),
      showInBestPracticeCustomization: z.boolean().optional(),
      showInQualifiers: z.boolean().optional(),
      manualEntryPrefix: z.string().optional(),
      manualEntryAllowedType: z.string().optional(),
      manualEntrySource: z.any().transform((val) => {
        try {
          return ApiDimensionTypesSchema.parse(val);
        } catch {
          return null;
        }
      }) as z.ZodType<ApiDimensionTypes | null>,
    })
    .optional(),
});
